export default __webpack_public_path__ + "static/electronic_white_board_b.7c99d544ba595ee51d1b1020d6f5e6b2.svg";